import { useState, useEffect } from 'react';
import { isFullscreen as checkFullscreen, isFullscreenSupported, toggleFullscreen as toggleFS } from './fullscreen';

export function useIsFullscreen() {
    const [isFullscreen, setIsFullscreen] = useState(checkFullscreen());
    useEffect(() => {
        function handleFullscreenChange() {
            setIsFullscreen(checkFullscreen());
        }
        // Préfixé sur les anciens Safari iPad (webkitRequestFullscreen) : sans lui,
        // l'icône ne suit jamais l'état réel.
        window.addEventListener('fullscreenchange', handleFullscreenChange);
        window.addEventListener('webkitfullscreenchange', handleFullscreenChange);
        return () => {
            window.removeEventListener('fullscreenchange', handleFullscreenChange);
            window.removeEventListener('webkitfullscreenchange', handleFullscreenChange);
        };
    }, []);

    return { isFullscreen };
}

export function useFullscreen() {
    const { isFullscreen } = useIsFullscreen();
    const toggleFullscreen = () => toggleFS(document.documentElement);
    // Constant pour la page : pas besoin d'état.
    const isSupported = isFullscreenSupported();

    return { isFullscreen, isSupported, toggleFullscreen };
}
